export const LOCATION_TYPE_OPTIONS = [
    { id: 1, title: "City" },
    { id: 2, title: "Highway" },
]

export const LOCATION_SUBTYPE_OPTIONS = [
    { id: 1, title: "Mall" },
    { id: 2, title: "Retail Outlet" },
    { id: 3, title: "Dealership" },
    { id: 4, title: "Residential" },
    { id: 5, title: "Hotel" },
    { id: 6, title: "Techparks" },
    { id: 7, title: "Hubs" },
    { id: 8, title: "Customer Site" },
]

export const deal_scope_of_work_options = [
    { id: 1, title: "Charger" },
    { id: 2, title: "SaaS" },
    { id: 3, title: "Infra (EPC)" },
    { id: 4, title: "Land Deal" },
    { id: 5, title: "O&M" },
]
export const COLOR_OPTIONS = [
    { color_code: "#4CAF50", name: "Green" },
    { color_code: "#F44336", name: "Red" },
    { color_code: "#3F51B5", name: "Blue" },
    { color_code: "#FF9800", name: "Orange" },
    { color_code: "#9C27B0", name: "Purple" },
    { color_code: "#00BCD4", name: "Cyan" },
    { color_code: "#607D8B", name: "Gray" },
]

export const Countries = [
    { id: 101, title: "India", currency: "INR" },
    { id: 229, title: "UAE", currency: "AED" },
    { id: 153, title: "Nepal", currency: "NPR" },
    { id: 238, title: "Vietnam", currency: "VND" },
]

export const ZONE_OPTIONS = [
    { id: "North", title: "North" },
    { id: "South", title: "South" },
    { id: "East", title: "East" },
    { id: "West", title: "West" },
    { id: "North-East", title: "North-East" },
    { id: "North-West", title: "North-West" },
    { id: "South-East", title: "South-East" },
    { id: "South-West", title: "South-West" },
    { id: "Central", title: "Central" },
]

export const CALL_TYPE_OPTIONS = [
    { id: "Breakdown", title: "Breakdown" },
    { id: "Preventive Maintenance", title: "Preventive Maintenance" },
    { id: "ECN", title: "ECN" },
    { id: "Commissioning", title: "Commissioning" },
    { id: "Survey", title: "Survey" },
]

export const CHARGER_TYPE_OPTIONS = [
    { id: "AC", title: "AC" },
    { id: "DC", title: "DC" },
]

export const CPO_ASSIGNED_DEPARTMENTS = [{ id: "Network Reliability", title: "Network Reliability" }]

/** Static descriptions for resolution types — backend list has no description field. */
export const RESOLUTION_TYPE_DESCRIPTIONS = {
    RESOLVED_REMOTELY: "Fixed via OCPP command, config push or remote reboot",
    RESOLVED_ONSITE: "Engineer visited the station — visit & expense capture required",
} as const

export const COMPLAINTS_STATUSES = [
    { id: "Open", name: "Open" },
    { id: "Attended", name: "Attended" },
    { id: "In Progress", name: "In-Progress" },
    { id: "Resolved", name: "Resolved" },
    { id: "Deferred", name: "Deferred" },
]
export const COMPLAINTS_PRIORITY = [
    { id: "Critical", title: "Critical" },
    { id: "High", title: "High" },
    { id: "Medium", title: "Medium" },
    { id: "Low", title: "Low" },
]

export const ASSIGNED_DEPARTMENTS = [
    { id: "Hardware Service", title: "Hardware Service" },
    { id: "Operations", title: "Operations" },
    { id: "Business", title: "Business" },
]
export const OUTRIGHT_ASSIGNED_DEPARTMENTS = [
    { id: "Sales", title: "Sales" },
    { id: "Operations", title: "Operations" },
    { id: "Customer Support", title: "Customer Support" },
    { id: "Hardware Service", title: "Hardware Service" },
]

export const MSME_REG_TYPE_OPTIONS = [
    { id: "Small", title: "Small" },
    { id: "Medium", title: "Medium" },
    { id: "Micro", title: "Micro" },
]

export const GST_TREATMENT_OPTIONS = [
    { id: "Registered Business- Regular", title: "Registered Business- Regular" },
    { id: "Registered Business- Composition", title: "Registered Business- Composition" },
    { id: "Unregistered", title: "Unregistered" },
    { id: "Overseas", title: "Overseas" },
    { id: "Special Economic Zone", title: "Special Economic Zone" },
    { id: "Deemed Export", title: "Deemed Export" },
    { id: "Tax Deductor", title: "Tax Deductor" },
    { id: "SEZ Developer", title: "SEZ Developer" },
]

export const BUDGET_CATEGORIES = [
    {
        id: "Charger",
        title: "Charger",
    },
    {
        id: "Raw material",
        title: "Raw material",
    },
    {
        id: "Contractor Cost",
        title: "Contractor Cost",
    },
    {
        id: "Travel",
        title: "Travel",
    },
    {
        id: "Others",
        title: "Others",
    },
]

export const EXPENSE_CATEGORY = [
    { id: "Travel", title: "Travel" },
    { id: "Food", title: "Food" },
    { id: "Other", title: "Other" },
    { id: "Loadging", title: "Lodging" },
]

export const WARRANT_STATUS = [
    { id: 1, title: "In Warranty" },
    { id: 2, title: "Out Warranty" },
]

export const YES_NO_OPTIONS = [
    { id: 1, title: "Yes" },
    { id: 0, title: "No" },
]

// Complaint DOA (Dead on Arrival). Filter ids are the backend tokens sent as doa=yes,no,blank.
export const DOA_FILTER_OPTIONS = [
    { id: "yes", title: "Yes" },
    { id: "no", title: "No" },
    { id: "blank", title: "Blank" },
]

// DOA value on raise/resolve. Ids are sent as-is ("true"/"false"); backend canonicalizes them.
export const DOA_OPTIONS = [
    { id: "true", title: "Yes" },
    { id: "false", title: "No" },
]

/**
 * Finance status of the finance ticket behind a logistics DR — child_status ids, sent as
 * `finance_status_ids`. Informational only: it does not affect the logistics status tabs.
 *
 * A DR with no finance ticket has a null finance_status, so it cannot match any id and is
 * excluded whenever this filter is set.
 */
export const FINANCE_STATUS_OPTIONS = [
    { id: 92, title: "Open" },
    { id: 93, title: "Approved" },
    { id: 94, title: "Verification In Progress" },
    { id: 95, title: "Paid In Full" },
    { id: 96, title: "On Hold" },
    { id: 97, title: "Dropped" },
    { id: 136, title: "Reject" },
]

// DFC approval status filter — ids are the API values ("Open" maps to not_submitted).
export const DFC_APPROVAL_STATUS_OPTIONS = [
    { id: "not_submitted", title: "Open" },
    { id: "submitted", title: "Submitted" },
    { id: "approved", title: "Approved" },
    { id: "rejected", title: "Rejected" },
]

export const ACCESS_TYPE_OPTIONS = [
    { id: 0, title: "Public" },
    { id: 1, title: "Captive" },
]

export const OPENING_HOURS_OPTIONS = [
    { id: 0, title: "Custom" },
    { id: 1, title: "24 hours" },
]

export const TYPE_OF_PROPERTY_OPTIONS = [
    { id: "rented", title: "Rented" },
    { id: "owned", title: "Owned/Self" },
]

export const AVAILABLE_CONNECTION_TYPE_OPTIONS = [
    { id: "commercial", title: "Commercial" },
    { id: "ev_connection", title: "EV Connection" },
]

export const VEHICLE_TYPE_OPTIONS = [
    { id: 1, title: "HCV" },
    { id: 2, title: "LCV" },
    { id: 3, title: "Bus" },
    { id: 4, title: "Truck" },
    { id: 5, title: "LMV" },
]

export const CSMS_PARTNER_OPTIONS = [
    {
        id: 1,
        title: "statiq",
    },
    {
        id: 2,
        title: "other",
    },
]

export const SENT_ON_OPTIONS = [
    { id: "delivery_challan", title: "Delivery Challan" },
    { id: "credit_note", title: "Credit Note" },
    { id: "tax_invoice", title: "Tax Invoice" },
    { id: "vendor_invoice", title: "Vendor Invoice" },
    { id: "vendor_delivery_challan", title: "Vendor Delivery Challan" },
]
export const VEHICLE_OPTIONS = [
    { id: "lmv", title: "LMV" },
    { id: "hcv", title: "HCV" },
    { id: "lcv", title: "LCV" },
    { id: "bus", title: "Bus" },
    { id: "truck", title: "Truck" },
]
export const PARKING_TYPE_OPTIONS = [
    { id: "Basement", title: "Basement" },
    { id: "Surface", title: "Surface" },
    { id: "Multi-level", title: "Multi-level" },
]
export const CAPITALISATION_STATUS_OPTIONS = [
    { id: "Capitalized", title: "Capitalised" },
    { id: "Decapitalized", title: "Decapitalised" },
    { id: "Pending Finance review", title: "Pending Finance review" },
]
export const OWNERSHIP_STATUS_OPTIONS = [
    { id: "opex", title: "Opex" },
    { id: "coco", title: "Coco" },
    { id: "co-owned", title: "Co-owned" },
    { id: "foco", title: "Foco" },
]
export const ECOM_DOWNLOAD_STATUS = [
    { id: 42, title: "Dispatched" },
    { id: 174, title: "Out for Delivery" },
    { id: 176, title: "Order Returned" },
    { id: 175, title: "Order Not Delivered" },
    { id: 43, title: "Delivered" },
]

/** Item Master */
export const PRODUCT_TYPE = [
    { id: "goods", title: "Goods" },
    { id: "services", title: "Services" },
]

export const ITEM_CATEGORY = [
    { id: "Finished Goods", title: "Finished Goods" },
    { id: "Raw Material", title: "Raw Material" },
    { id: "Supply Material", title: "Supply Material" },
    { id: "Consumable Goods", title: "Consumable Goods" },
    { id: "Miscellaneous", title: "Miscellaneous" },
    { id: "Other", title: "Other" },
]

export const CHARGER_TYPE = [
    { id: "ac", title: "AC" },
    { id: "dc", title: "DC" },
]

export const TAX_PREFERENCE = [
    { id: "Taxable", title: "Taxable" },
    { id: "Non Taxable", title: "Non Taxable" },
    { id: "Out of scope", title: "Out of scope" },
    { id: "Non GST Supply", title: "Non GST Supply" },
]

export const PAYMENT_STATUSES = [
    { id: "Verified", title: "Verified" },
    { id: "Pending", title: "Pending" },
    { id: "Rejected", title: "Rejected" },
]

export const CONNECTION_TYPE_OPTIONS = [
    { id: "single_phase", title: "Single Phase" },
    { id: "three_phase", title: "Three Phase" },
    { id: "ev_connection", title: "EV Connection" },
    { id: "commercial", title: "Commercial" },
]

export const CONNECTION_OWNED_BY_OPTIONS = [
    { id: "client", title: "Client" },
    { id: "statiq", title: "Statiq" },
]

export const FOUNDATION_TYPE_OPTIONS = [
    { id: "wall_mount", title: "Wall Mount" },
    { id: "pedestal", title: "Pedestal" },
    { id: "ground_mount", title: "Ground Mount" },
]

export const EXPENSE_TYPE_OPTIONS = [
    {
        id: "CapEx",
        title: "CapEx",
    },
    {
        id: "OpEx",
        title: "OpEx",
    },
]

export const EXPENSE_ITEM_CATEGORY_OPTIONS = [
    {
        id: "Charger Infra",
        title: "Charger Infra",
    },
    {
        id: "Power Infra",
        title: "Power Infra",
    },
]

export const PAYMENT_TYPE_OPTIONS = [
    {
        id: "advance",
        title: "Advance",
    },
    {
        id: "part",
        title: "Part",
    },
    {
        id: "full_and_final",
        title: "Full&Final",
    },
    {
        id: "full",
        title: "Full",
    },
]

export const PROJECT_CATEGORY_OPTIONS = [
    { title: "Home Charging", id: "Home Charging" },
    { title: "OPS SCM RM", id: "OPS SCM RM" },
    { title: "Franchise", id: "Franchise" },
    { title: "EPC Projects", id: "EPC Projects" },
    { title: "Statiq CPO", id: "Statiq CPO" },
]

export const TRANSACTION_STATUS_OPTIONS = [
    { title: "Approved", id: "approved" },
    { title: "Rejected", id: "rejected" },
    { title: "On-hold", id: "on_hold" },
]

export const VEHICLE_MODELS = [
    { id: "EV6 PE", title: "EV6 PE" },
    { id: "Kia EV9", title: "Kia EV9" },
    { id: "Clavis EV", title: "Clavis EV" },
]

/**
 * How a task in the Task List Master closes (handover §9, `source_key`).
 *
 * The five ids are a fixed backend enum, so they live here rather than coming from an API.
 * `as const` matters: TaskListMasterService derives its `SourceKey` type from these ids, so
 * this array is the single source of truth for both the dropdown and the type.
 *
 * The module list is deliberately NOT here — it comes from
 * GET /v3/settings/task-master/modules, because modules get enabled over time.
 */
export const TASK_SOURCE_OPTIONS = [
    { id: "manual", title: "Manual close with proof" },
    { id: "approval", title: "Approval flow" },
    { id: "survey", title: "Survey ticket" },
    { id: "charger", title: "Charger status" },
    { id: "dispatch", title: "Dispatch tickets" },
] as const
